module.exports = __webpack_public_path__ + "static/media/cu07.539105a4.png";